export type SalesReportSlug =
  | 'packaging'
  | 'food-and-drink'
  | 'result-overview'
  | 'emissions-over-time'
  | 'carbon-intensity-over-time'
  | 'emissions-by-site'
  | 'emissions-by-customer'
  | 'emissions-by-supplier'
  | 'emissions-by-tag'
  | 'emissions-by-category'
  | 'sold-items-food'
  | 'emissions-by-material'
  | 'sold-items-packaging';

export type SalesReportSlugs = Record<string, SalesReportSlug>;

export const salesReportSlugs = {
  packaging: 'packaging',
  foodAndDrink: 'food-and-drink',
  resultOverview: 'result-overview',
  emissionsOverTime: 'emissions-over-time',
  emissionsBySite: 'emissions-by-site',
  emissionsByCustomer: 'emissions-by-customer',
  emissionsBySupplier: 'emissions-by-supplier',
  emissionsByTag: 'emissions-by-tag',

  emissionsByCategory: 'emissions-by-category',
  soldItemsFood: 'sold-items-food',

  emissionsByMaterial: 'emissions-by-material',
  soldItemsPackaging: 'sold-items-packaging',
};
